import { Link } from 'react-router'
import { GUIDES } from '../content/guides'

const featuredSlugs = new Set([
  'public-procurement',
  'how-to-bid-on-government-contracts',
  'government-contractor-certifications',
  'prevailing-wage',
])

export default function GuidesSection() {
  const featured = GUIDES.filter((guide) => featuredSlugs.has(guide.slug))
  return (
    <section className="relative py-24 bg-[#0a0e14] border-y border-white/[0.05]">
      <div className="max-w-[1280px] mx-auto px-6">
        <div className="max-w-[720px] mb-10">
          <span className="text-xs font-mono uppercase tracking-[0.1em] text-[#06b6d4]">Learn public contracting</span>
          <h2 className="mt-3 text-[clamp(28px,3vw,42px)] font-semibold tracking-[-0.02em] text-white">Understand the process before you bid</h2>
          <p className="mt-4 text-[16px] leading-[1.7] text-[#9ca3af]">Practical, source-backed introductions to government procurement, compliant bidding, certifications, and public-project requirements.</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {featured.map((guide) => (
            <Link key={guide.slug} to={`/guides/${guide.slug}`} className="group rounded-xl border border-white/[0.08] bg-white/[0.025] p-6 hover:border-[#06b6d4]/50 transition-colors">
              <h3 className="text-base font-semibold text-white group-hover:text-[#22d3ee] transition-colors">{guide.shortTitle}</h3>
              <p className="mt-3 text-sm leading-[1.6] text-[#9ca3af]">{guide.description}</p>
              <span className="mt-5 inline-block text-sm text-[#06b6d4]">Read guide →</span>
            </Link>
          ))}
        </div>
        <Link to="/guides" className="mt-8 inline-flex text-sm font-semibold text-white hover:text-[#06b6d4] transition-colors">Browse all government contracting guides →</Link>
      </div>
    </section>
  )
}
